import { render, staticRenderFns } from "./ContactCustomer.vue?vue&type=template&id=2de02a04"
import script from "./ContactCustomer.vue?vue&type=script&lang=js"
export * from "./ContactCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports